/** Event has at least one successful payment (PIX parcelado entrada or total). */
export function isEventPaymentStarted(statusPayments: string | null | undefined): boolean {
  const normalized = String(statusPayments ?? "").toLowerCase().trim();
  return (
    normalized === "paid" ||
    normalized === "partially_paid" ||
    normalized === "pago" ||
    normalized === "approved" ||
    normalized === "aprovado"
  );
}

/** Event is fully settled (all installments / single capture complete). */
export function isEventFullyPaid(statusPayments: string | null | undefined): boolean {
  const normalized = String(statusPayments ?? "").toLowerCase().trim();
  return (
    normalized === "paid" ||
    normalized === "pago" ||
    normalized === "approved" ||
    normalized === "aprovado"
  );
}

/** Checkout should redirect away — payment started or legacy programado status. */
export function isEventCheckoutComplete(
  statusPayments: string | null | undefined,
  eventStatus: string | null | undefined,
): boolean {
  if (isEventPaymentStarted(statusPayments)) return true;
  const status = String(eventStatus ?? "").toLowerCase().trim();
  return ["pago", "programado", "finalizado", "entregue", "fechado", "concluido"].includes(status);
}
